import React, {
  useEffect,
  useState,
} from 'react';

import {
  useLocation,
  useNavigate,
} from 'react-router-dom';

import {
  FontAwesomeIcon,
} from '@fortawesome/react-fontawesome';

import {
  faArrowLeft,
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';

import LeftLessonRenderer
  from './components/LeftLessonRenderer.jsx';

import RightLessonRenderer
  from './components/RightLessonRenderer.jsx';

import {
  completeUnitCourseLesson,
  CONTA_PRIMARA_COURSE_ID,
} from '../shared/unitCourseProgress';

import './ContaPrimara.css';


const ContaPrimara = () => {
  const navigate =
    useNavigate();

  const location =
    useLocation();


  /* =====================================================
     DATE PRIMITE DIN PAGINA CURSULUI
  ===================================================== */

  const {
    unitId,
    lessonId,
    unitTitle,
    lessonTitle,
  } =
    location.state || {};


  /* =====================================================
     LECTIA DIN BACKEND
  ===================================================== */

  const [
    lesson,
    setLesson,
  ] =
    useState(null);

  const [
    loading,
    setLoading,
  ] =
    useState(true);

  const [
    error,
    setError,
  ] =
    useState(null);


  /* =====================================================
     PAS CURENT
  ===================================================== */

  const [
    currentStepIndex,
    setCurrentStepIndex,
  ] =
    useState(0);


  /* =====================================================
     INCARCARE LECTIE DIN DATABASE
  ===================================================== */

  useEffect(() => {
    if (
      !unitId ||
      !lessonId
    ) {
      setLoading(false);
      return;
    }

    const loadLesson =
      async () => {
        try {
          setLoading(true);
          setError(null);

          const response =
            await fetch(
              `${process.env.REACT_APP_API_URL}/contaprimara/${unitId}/lesson/${lessonId}`,
              {
                credentials:
                  'include',
              }
            );

          if (
            !response.ok
          ) {
            throw new Error(
              `Lectia nu a putut fi incarcata. Status: ${response.status}`
            );
          }

          const data =
            await response.json();

          console.log(
            'Lectie contaprimara din DB:',
            data
          );

          setLesson(
            data
          );

          setCurrentStepIndex(
            0
          );

        } catch (err) {
          console.error(
            'Eroare la incarcarea lectiei:',
            err
          );

          setError(
            err.message
          );

        } finally {
          setLoading(false);
        }
      };

    loadLesson();

  }, [
    unitId,
    lessonId,
  ]);


  /* =====================================================
     DATE PAS
  ===================================================== */

  const totalSteps =
    lesson?.steps?.length ||
    0;


  const currentStepData =
    lesson?.steps?.[
      currentStepIndex
    ] ||
    null;


  /* =====================================================
     FACTURA LECTIEI

     Cautam factura in toti pasii lectiei.
     Astfel factura poate fi definita o singura data
     si reutilizata in pasii urmatori.
  ===================================================== */

  const currentInvoice =
    lesson?.steps
      ?.map(
        (step) =>
          step?.right?.invoice
      )
      ?.find(Boolean) ||
    null;


  /* =====================================================
     PROGRES
  ===================================================== */

  const progress =
    totalSteps > 0
      ? (
          (
            currentStepIndex +
            1
          ) /
          totalSteps
        ) *
        100
      : 0;


  /* =====================================================
     INAPOI
  ===================================================== */

  const handleBack = () => {
    if (
      currentStepIndex >
      0
    ) {
      setCurrentStepIndex(
        (prev) =>
          prev - 1
      );
    }
  };


  /* =====================================================
     CONTINUA
  ===================================================== */

  const handleNext = async () => {
    if (
      currentStepIndex <
      totalSteps - 1
    ) {
      setCurrentStepIndex(
        (prev) =>
          prev + 1
      );

      return;
    }

    // Lectia s-a terminat: o salvam inainte de a reveni la curs,
    // ca pagina cursului sa o vada deja bifata.
    await completeUnitCourseLesson(
      CONTA_PRIMARA_COURSE_ID,
      unitId,
      lessonId
    );

    navigate(
      '/functionalpagelogin'
    );
  };


  /* =====================================================
     IESIRE
  ===================================================== */

  const handleExit = () => {
    navigate(
      '/functionalpagelogin'
    );
  };


  /* =====================================================
     PROTECTIE - DATE NAVIGARE
  ===================================================== */

  if (
    !unitId ||
    !lessonId
  ) {
    return (
      <div className="conta-primara-page">

        <div className="conta-primara-loading">

          <p>
            Lectia nu a fost selectata.
          </p>

          <button
            type="button"
            onClick={
              handleExit
            }
          >
            Inapoi la curs
          </button>

        </div>

      </div>
    );
  }


  /* =====================================================
     LOADING
  ===================================================== */

  if (loading) {
    return (
      <div className="conta-primara-page">

        <div className="conta-primara-loading">

          <p>
            Se incarca lectia...
          </p>

        </div>

      </div>
    );
  }


  /* =====================================================
     ERROR
  ===================================================== */

  if (error) {
    return (
      <div className="conta-primara-page">

        <div className="conta-primara-loading">

          <p>
            {error}
          </p>

          <button
            type="button"
            onClick={
              handleExit
            }
          >
            Inapoi la curs
          </button>

        </div>

      </div>
    );
  }


  /* =====================================================
     PROTECTIE - LECTIA NU EXISTA
  ===================================================== */

  if (
    !lesson
  ) {
    return (
      <div className="conta-primara-page">

        <div className="conta-primara-loading">

          <p>
            Lectia nu a putut fi incarcata.
          </p>

          <button
            type="button"
            onClick={
              handleExit
            }
          >
            Inapoi la curs
          </button>

        </div>

      </div>
    );
  }


  /* =====================================================
     PROTECTIE - LECTIA NU ARE CONTINUT
  ===================================================== */

  if (
    !currentStepData
  ) {
    return (
      <div className="conta-primara-page">

        <div className="conta-primara-loading">

          <p>
            Aceasta lectie nu are continut disponibil.
          </p>

          <button
            type="button"
            onClick={
              handleExit
            }
          >
            Inapoi la curs
          </button>

        </div>

      </div>
    );
  }


  /* =====================================================
     RENDER
  ===================================================== */

  return (
    <div className="conta-primara-page">


      {/* =================================================
          HEADER
      ================================================= */}

      <header className="conta-primara-header">

        <button
          type="button"
          className="conta-primara-exit"
          onClick={
            handleExit
          }
          aria-label="Inapoi la curs"
        >
          <FontAwesomeIcon
            icon={
              faArrowLeft
            }
          />
        </button>


        <div className="conta-primara-header-title">

          <span>
            {
              unitTitle ||
              'Contabilitate primara'
            }
          </span>

          <strong>
            {
              lessonTitle ||
              lesson.title
            }
          </strong>

        </div>


        <div
          className="conta-primara-progress"
          role="progressbar"
          aria-valuemin="0"
          aria-valuemax="100"
          aria-valuenow={
            Math.round(
              progress
            )
          }
        >

          <div
            className="conta-primara-progress-fill"
            style={{
              width:
                `${progress}%`,
            }}
          />

        </div>

      </header>


      {/* =================================================
          WORKSPACE
      ================================================= */}

      <main className="conta-primara-workspace">


        {/* ===============================================
            STANGA
        =============================================== */}

        <section className="conta-primara-lesson">

          <div className="conta-primara-lesson-scroll">

            <LeftLessonRenderer
              content={
                currentStepData.left
              }
              lesson={
                lesson
              }
              step={
                currentStepData
              }
              invoice={
                currentInvoice
              }
            />

          </div>

        </section>


        {/* ===============================================
            DREAPTA
        =============================================== */}

        <section className="conta-primara-interactive">


          <div className="conta-primara-interactive-header">

            {
              currentStepData
                ?.right
                ?.header ||
              'Document'
            }

          </div>


          <div className="conta-primara-interactive-content">

            <div className="conta-primara-interactive-stage">

              <RightLessonRenderer
                content={
                  currentStepData.right
                }
                invoice={
                  currentInvoice
                }
              />

            </div>

          </div>

        </section>

      </main>


      {/* =================================================
          FOOTER
      ================================================= */}

      <footer className="conta-primara-bottom-bar">


        <button
          type="button"
          className="conta-primara-nav-btn"
          onClick={
            handleBack
          }
          disabled={
            currentStepIndex ===
            0
          }
        >

          <FontAwesomeIcon
            icon={
              faChevronLeft
            }
          />

          <span>
            Inapoi
          </span>

        </button>


        <div className="conta-primara-step">

          {
            currentStepIndex +
            1
          }

          {' / '}

          {
            totalSteps
          }

        </div>


        <button
          type="button"
          className="
            conta-primara-nav-btn
            conta-primara-nav-btn-next
          "
          onClick={
            handleNext
          }
        >

          <span>
            {
              currentStepIndex ===
              totalSteps - 1
                ? 'Finalizeaza'
                : 'Continua'
            }
          </span>

          <FontAwesomeIcon
            icon={
              faChevronRight
            }
          />

        </button>

      </footer>

    </div>
  );
};


export default ContaPrimara;